import transportRequestSlice from './reducer'

export default transportRequestSlice.reducer
